import { LOCALE_KEY } from "../common/consts";
import { ELocales } from "../common/enums";

export const getLocale = (): ELocales => {
  return (localStorage.getItem(LOCALE_KEY) || ELocales.default) as ELocales;
};
